const TrackerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    fill="none"
    {...props}
  >
    <path
      fill="#00bc90"
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H59.08A6.919 6.919 0 0 1 66 6.919V59.08A6.919 6.919 0 0 1 59.081 66H6.92A6.919 6.919 0 0 1 0 59.081V6.92Z"
    />
    <path
      fill="#fff"
      fillOpacity={0.9}
      d="M0 6.919A6.919 6.919 0 0 1 6.919 0H59.08A6.919 6.919 0 0 1 66 6.919V59.08A6.919 6.919 0 0 1 59.081 66H6.92A6.919 6.919 0 0 1 0 59.081V6.92Z"
    />
    <path
      fill="#00bc90"
      fillRule="evenodd"
      d="M48.44 23.813V17.25h-6.563v2.625h1.748l-7.797 6.243-7.292-2.558-10.105 4.593 1.087 2.39 9.144-4.158 7.67 2.692 9.482-7.592v2.328h2.625Zm-.59 24.784v-21h-7.876v21h7.876ZM42.6 30.222h2.624v15.75H42.6v-15.75Zm-5.25 0v18.375h-7.876V30.222h7.875Zm-2.626 2.625H32.1v13.125h2.624V32.847Zm-7.874-.875v16.625h-7.876V31.972h7.875Zm-2.626 2.625H21.6v11.375h2.625V34.597Z"
      clipRule="evenodd"
    />
    <path
      fill="#000"
      fillOpacity={0.4}
      fillRule="evenodd"
      d="M48.44 23.813V17.25h-6.563v2.625h1.748l-7.797 6.243-7.292-2.558-10.105 4.593 1.087 2.39 9.144-4.158 7.67 2.692 9.482-7.592v2.328h2.625Zm-.59 24.784v-21h-7.876v21h7.876ZM42.6 30.222h2.624v15.75H42.6v-15.75Zm-5.25 0v18.375h-7.876V30.222h7.875Zm-2.626 2.625H32.1v13.125h2.624V32.847Zm-7.874-.875v16.625h-7.876V31.972h7.875Zm-2.626 2.625H21.6v11.375h2.625V34.597Z"
      clipRule="evenodd"
    />
  </svg>
);
export default TrackerIcon;
